module.exports = __webpack_public_path__ + "media/images/5-1dfe0106.png";